import { compose, createStore, applyMiddleware} from 'redux';
import Thunk from 'redux-thunk';
import {namespace} from './common/Utils';
import {localeSelector} from './lw/Util';

import reducer from './lw/reducer';
import {actions} from './lw/reducer';
import Router from './lw/Router';

import SearchBox from './lw/components/SearchBox';
import SideMain from './lw/polymorph/SideMain';
import List from './lw/polymorph/List'
import ListFavorite from './lw/components/ListFavorite';
import Detail from './lw/detail/Detail';

class App {
    constructor(_config = {}) {
        // console.log('---------------------------- App start ----------------------------');

        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        this.store = createStore(reducer, composeEnhancers(applyMiddleware(Thunk)));
        _config.locale = localeSelector(document.documentElement.lang);
        this.store.dispatch(actions.setConfig(_config));
        this.router = new Router( this.store );
        
        this.search = new SearchBox('polymorphs', this.store, actions, this.router, '');
        this.side = new SideMain('SideMain', this.store, actions, this.router, '');
        this.list = new List('List', this.store, actions, this.router, '.gameinfo-result__list .ui-table .tablebody');
        this.favorite = new ListFavorite('ListFavorite', this.store, actions, this.router, '.gameinfo-result-wrapper');
        this.detail = new Detail('Detail', this.store, actions, this.router, '.gameinfo-detail-wrapper');
        
        this.router.init();
    }
}

namespace('nc.lw.polymorph');
nc.lw.polymorph = App;